<template>
  <div class="canvas-container col-12 col-md-6" :class="{'one-box': isOneBox}">
    <div class="canvas" ref="canvas"
      :class="{'double': (boxnum == 1), 'single': (boxnum > 1)}">
      <span class="bar"></span>
      <span
        v-for="note in displayNotes"
        class="noteimg"
        :style="{left: calcLeftPosition(note.start)}"
        :key="note.start"
        >
          <img
            :src="generateImgSrc(note.length, note.onoff)"
            width="30" height="60" />
          <span
            v-if="note.dotted"
            class="dot"
            :style="{left: '24px'}"></span>
          <img
            v-if="note.tie"
            class="tie"
            src="/img/tie.png"
            :style="calcTiePosition(note.start)"
            height="15" />
          <img
            v-if="isTriplet(note.length)"
            class="triplet"
            src="/img/triplet.png"
            width="10" height="10"
             />
        </span>
        <img
            v-if="isTieNextBox"
            src="/img/tie.png"
            :style="calcTiePositionBetweenBox()"
            height="15"
            class="d-md-none"/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'canvasbox',
  props: {
    score: {type: Array, required: true},
    boxnum: {type: Number, required: true}
  },
  data: function(){
    return{
      boxWidth: undefined,
    }
  },
  mounted: function(){
    const target = this.$refs.canvas;
    this.boxWidth = target.clientWidth;
    window.addEventListener('resize', () => {
      this.boxWidth = target.clientWidth;
    }, false);
  },
  methods: {
    calcLeftPosition: function(start){//start: Number
      const startInBox = start - 3840*(this.boxnum - 1);
      const ratio = startInBox / 3840;
      return ratio * this.boxWidth + 'px';
    },
    dotLeftPosition: function(start){
      const startInBox = start - 3840*(this.boxnum - 1);
      const ratio = startInBox / 3840;
      console.log(this.boxWidth);
      return ((ratio * this.boxWidth) + 24) + 'px';
    },
    calcTiePosition: function(start){
      const prevNotes = this.score.filter(note => note.start < start);
      const prevLastNote = prevNotes[prevNotes.length-1];//ここで一個前の音符を取得
      const leftRatio = ((prevLastNote.start - start) % 3840) / 3840;
      const left = ((leftRatio * this.boxWidth) + 9) + 'px';//ここでleft値を計算
      const widthRatio = (start - prevLastNote.start) / 3840;
      const width = ((widthRatio * this.boxWidth) + 1) + 'px';//ここでwidth値を計算
      return {'left': left, 'width': width};
    },
    calcTiePositionBetweenBox: function(){
      const lastNote = this.displayNotes[this.displayNotes.length-1];//ここで最後の音符を取得
      const leftRatio = (lastNote.start % 3840) / 3840;
      const left = ((leftRatio * this.boxWidth) + 9) + 'px';//ここでleft値を計算
      const widthRatio = (3840 - lastNote.start) / 3840;
      const width = ((widthRatio * this.boxWidth) + 1) + 'px';//ここでwidth値を計算
      return {'left': left, 'width': width, 'top': '80px'};
    },
    generateImgSrc: function(length, onoff){
      const num = 3840 / length;
      const name = onoff ? 'on' : 'off';
      return "/img/" + num + name + ".png";
    },
    isTriplet: function (length) {
      const triplets = [640, 320, 160];
      return triplets.includes(length);
    },
  },
  computed: {
    displayNotes: function(){
      return this.score.filter(obj => {
        return ((this.boxnum - 1) * 3840 <= obj.start) && (obj.start < this.boxnum * 3840);
        //TO DO// 小説を挟んだ音符
      })
    },
    isTieNextBox: function(){
      let lastNoteInThisBox = this.displayNotes[this.displayNotes.length-1];
      let nextNoteInNextBox = this.score.filter(note => note.start > lastNoteInThisBox.start)
      return Boolean((nextNoteInNextBox.length !== 0) && (nextNoteInNextBox[0].tie));
    },
    isOneBox: function(){
      return this.$store.getters.boxNum === 1;
    }
  }
}
</script>

<style scoped>
.canvas-container{
  position: relative;
  padding: 0 20px 0 10px;
}
@media screen and (min-width: 768px) {
.canvas-container{
  padding: 0;  
}
.one-box{
  margin: 0 25%;
}
}
.canvas{
  position: relative;
  display: block;
  height: 100px;
  width: 100%;
  margin: 0;
  padding: 0;
}
.canvas.double{
  border-left: 4px double #333;
}
.canvas.single{
  border-left: 1px solid #333;
  padding-left: 3px;
}
.canvas *{
  position: absolute;
  display: block;
  margin: 0;
  padding: 0;
  background-color: rgba(0,0,0,0);  
}
.bar{
  width: 100%;
  height: 0;
  top: 75px;
  left: 0;
  border-top: 1px solid #333;
}
.noteimg{top: 30px}
.dot{
  content: '';
  width: 4px;
  height: 4px;
  top: 40px;
  background-color: #000;
  border-radius: 50%;
}
.tie{
  top: 52px;
}
.triplet{
  top: -8px;
  left: 14px;
}
</style>
